import {useMutation} from 'react-query';
import {postInstallmentCardToCardPayment} from './postInstallmentCardToCardPayment';

interface UsePostInstallmentCardToCardPaymentOptions {
  onSuccess?: (
    data: any,
    variables: IPostInstallmentCardToCardPayment,
    context: unknown,
  ) => void;
  onError?: (
    error: Error,
    variables: IPostInstallmentCardToCardPayment,
    context: unknown,
  ) => void;
}

const usePostInstallmentCardToCardPayment = (
  options?: UsePostInstallmentCardToCardPaymentOptions,
) => {
  const {mutate, isLoading, isSuccess, data, error, ...rest} = useMutation({
    mutationFn: (payload: IPostInstallmentCardToCardPayment) =>
      postInstallmentCardToCardPayment(payload),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    mutate,
    isLoading,
    isSuccess,
    data,
    error,
    ...rest,
  };
};

export default usePostInstallmentCardToCardPayment;
